import SuperRepository from '../superRepository'

export default new (class SettingsRepository extends SuperRepository {
  baseUri() {
    return 'setting'
  }
})()
